import XlsxPopulate from 'xlsx-populate';

/**
 * base64文字列からExcelファイル（Blob）を生成する
 * @param base64Data - Lambdaなどから返ってきたbase64文字列
 * @returns ExcelファイルのBlob（application/vnd.openxmlformats-officedocument.spreadsheetml.sheet）
 */
export const convertBase64ToExcelBlob = async (base64Data: string): Promise<Blob> => {
  // base64 → Uint8Array に変換
  const binary = atob(base64Data);
  const buffer = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    buffer[i] = binary.charCodeAt(i);
  }

  // Excelワークブックを読み込む
  const workbook = await XlsxPopulate.fromDataAsync(buffer.buffer);

  // Blobに変換して返す
  const blobBuffer = await workbook.outputAsync();
  return new Blob([blobBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
};
